import React from 'react'

const ButtonElement = props => {
  const { styles, text } = props.item.content
  return (
    <div ref={this.rootEl}>
      <button style={styles}>{text}</button>
    </div>
  )
}

export default ButtonElement



// WEBPACK FOOTER //
// ./src/components/commons/editor/ButtonElement.js